import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cf-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('fechar');
      }
    }
  }, [_c('div', {
    staticClass: "cf-modal"
  }, [_c('div', {
    staticClass: "cf-modal__header"
  }, [_c('div', [_vm._m(0), _vm.nfce ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" NFC-e #" + _vm._s(_vm.nfce.numero) + " · Série " + _vm._s(_vm.nfce.serie) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "cf-btn cf-btn--light",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "cf-modal__body"
  }, [_vm.rejeicao ? _c('div', {
    staticClass: "cf-alert cf-alert--danger"
  }, [_c('i', {
    staticClass: "fas fa-ban mr-2"
  }), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.nfce.codigo_rejeicao ? "Rejei\xE7\xE3o ".concat(_vm.nfce.codigo_rejeicao) : 'Rejeitada') + ":")]), _vm._v(" " + _vm._s(_vm.rejeicao.mensagem) + " ")])]) : _vm._e(), _vm.carregando ? _c('div', {
    staticClass: "text-center py-4 text-muted"
  }, [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }), _vm._v(" Carregando itens... ")]) : [_vm.itens.length > 1 && _vm.rejeicao && _vm.rejeicao.nItem == null ? _c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v("Item a corrigir")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nItemSelecionado,
      expression: "nItemSelecionado"
    }],
    staticClass: "cf-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.nItemSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.itens, function (it, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i + 1
      }
    }, [_vm._v(" " + _vm._s(i + 1) + ". " + _vm._s(it.descricao) + " (" + _vm._s(it.quantidade) + "x R$" + _vm._s(_vm.fmtBRL(it.valor_unitario)) + ") ")]);
  }), 0)]) : _vm._e(), _vm.itemAtual ? _c('div', {
    staticClass: "cf-item-card"
  }, [_c('div', {
    staticClass: "cf-item-card__title"
  }, [_c('i', {
    staticClass: "fas fa-box mr-1"
  }), _vm._v(" Item " + _vm._s(_vm.nItemSelecionado) + ": "), _c('strong', [_vm._v(_vm._s(_vm.itemAtual.descricao))])]), _c('div', {
    staticClass: "cf-item-card__sub"
  }, [_vm._v(" Qtd: " + _vm._s(_vm.itemAtual.quantidade) + " · Unitário: R$ " + _vm._s(_vm.fmtBRL(_vm.itemAtual.valor_unitario)) + " · Total: R$ " + _vm._s(_vm.fmtBRL(_vm.itemAtual.total)) + " ")])]) : _vm._e(), _vm.itemAtual ? _c('div', {
    staticClass: "cf-fiscal-form"
  }, [_c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v(" CSOSN "), _vm.rejeicao && _vm.rejeicao.campo === 'CSOSN' ? _c('span', {
    staticClass: "cf-badge cf-badge--danger ml-1"
  }, [_vm._v(" campo rejeitado ")]) : _vm._e()]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.csosn,
      expression: "form.csosn"
    }],
    staticClass: "cf-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "csosn", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.csosnOpcoes, function (op) {
    return _c('option', {
      key: op.value,
      domProps: {
        "value": op.value
      }
    }, [_vm._v(_vm._s(op.label))]);
  }), 0), _vm._m(1)]), _c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v(" CFOP "), _vm.rejeicao && _vm.rejeicao.campo === 'CFOP' ? _c('span', {
    staticClass: "cf-badge cf-badge--danger ml-1"
  }, [_vm._v(" campo rejeitado ")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cfop,
      expression: "form.cfop"
    }],
    staticClass: "cf-input",
    attrs: {
      "type": "text",
      "maxlength": "7",
      "placeholder": "ex: 5102"
    },
    domProps: {
      "value": _vm.form.cfop
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cfop", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v(" NCM "), _vm.rejeicao && _vm.rejeicao.campo === 'NCM' ? _c('span', {
    staticClass: "cf-badge cf-badge--danger ml-1"
  }, [_vm._v(" campo rejeitado ")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.ncm,
      expression: "form.ncm"
    }],
    staticClass: "cf-input",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "ex: 22021000"
    },
    domProps: {
      "value": _vm.form.ncm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "ncm", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v(" CST PIS "), _vm.rejeicao && _vm.rejeicao.campo === 'CST_PIS' ? _c('span', {
    staticClass: "cf-badge cf-badge--danger ml-1"
  }, [_vm._v(" campo rejeitado ")]) : _vm._e()]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cst_pis,
      expression: "form.cst_pis"
    }],
    staticClass: "cf-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "cst_pis", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("07 – Operação Isenta da Contribuição")]), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("08 – Operação sem Incidência da Contribuição")]), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("49 – Outras Operações de Saída")]), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("99 – Outras Operações")])])]), _c('div', {
    staticClass: "cf-form-group"
  }, [_c('label', {
    staticClass: "cf-label"
  }, [_vm._v(" CST COFINS "), _vm.rejeicao && _vm.rejeicao.campo === 'CST_COFINS' ? _c('span', {
    staticClass: "cf-badge cf-badge--danger ml-1"
  }, [_vm._v(" campo rejeitado ")]) : _vm._e()]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cst_cofins,
      expression: "form.cst_cofins"
    }],
    staticClass: "cf-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "cst_cofins", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("07 – Operação Isenta da Contribuição")]), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("08 – Operação sem Incidência da Contribuição")]), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("49 – Outras Operações de Saída")]), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("99 – Outras Operações")])])])]) : _vm._e()], _vm.erro ? _c('div', {
    staticClass: "cf-alert cf-alert--danger mt-2"
  }, [_vm._v(_vm._s(_vm.erro))]) : _vm._e(), _vm.sucesso ? _c('div', {
    staticClass: "cf-alert cf-alert--success mt-2"
  }, [_vm._v(_vm._s(_vm.sucesso))]) : _vm._e()], 2), _c('div', {
    staticClass: "cf-modal__footer"
  }, [_c('button', {
    staticClass: "cf-btn cf-btn--secondary",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "cf-btn cf-btn--primary",
    attrs: {
      "disabled": _vm.salvando || !_vm.itemAtual
    },
    on: {
      "click": _vm.salvarCorrecao
    }
  }, [_vm.salvando ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Salvando... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-save mr-1"
  }), _vm._v("Salvar Correção ")])]), _vm.correcaoSalva ? _c('button', {
    staticClass: "cf-btn cf-btn--warning",
    attrs: {
      "disabled": _vm.regenerando
    },
    on: {
      "click": _vm.gerarEAssinar
    }
  }, [_vm.regenerando ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Gerando... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-file-code mr-1"
  }), _vm._v("Gerar e Assinar Novamente ")])]) : _vm._e(), _vm.xmlPronto ? _c('button', {
    staticClass: "cf-btn cf-btn--success",
    attrs: {
      "disabled": _vm.transmitindo
    },
    on: {
      "click": _vm.transmitir
    }
  }, [_vm.transmitindo ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Transmitindo... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-paper-plane mr-1"
  }), _vm._v("Transmitir Novamente ")])]) : _vm._e()])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h4', {
    staticClass: "cf-modal__title"
  }, [_c('i', {
    staticClass: "fas fa-tools mr-2"
  }), _vm._v("Corrigir Dados Fiscais ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('small', {
    staticClass: "cf-hint"
  }, [_vm._v(" Para NFC-e Simples Nacional sem crédito, use "), _c('strong', [_vm._v("102")]), _vm._v(". ")]);
}];
export { render, staticRenderFns };